<template>
  <Integration v-bind="$attrs" v-on="$listeners" />
</template>

<script>
import Integration, { meta as globalMeta } from '@/components/Integration/Step'

const meta = { ...globalMeta, order: 1 }

export { meta }
export default {
  components: {
    Integration,
  },
}
</script>
